import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyCostDocumentNumberToAllBookingItemsCommand extends BaseCommand {
  CommandName = "CopyCostDocumentNumberToAllBookingItems";
  Command: {
    Value: string;
  };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
